/* WAKA header — reveal on scroll-up, hide on scroll-down, compact + solidify
   once scrolled. The announcement marquee scrolls away first (normal flow).
   No framework. Honours prefers-reduced-motion via CSS. */
(function () {
  var nav = document.querySelector('.nav');
  if (!nav) return;
  var last = window.scrollY || 0;
  var ticking = false;

  function update() {
    var y = window.scrollY || 0;
    nav.classList.toggle('is-scrolled', y > 40);
    if (y > last && y > 160) {
      nav.classList.add('is-hidden');        // scrolling down past the fold → hide
    } else if (y < last) {
      nav.classList.remove('is-hidden');     // scrolling up → reveal
    }
    last = y;
    ticking = false;
  }

  window.addEventListener('scroll', function () {
    if (!ticking) { ticking = true; window.requestAnimationFrame(update); }
  }, { passive: true });

  update();
})();
